import { z } from 'zod';
import { meta } from '../meta';

export const ImagePropsSchema = z.object({
  src: z.string().default('').meta(meta({ label: '图片', setter: 'image' })),
  fit: z.enum(['cover', 'contain', 'fill']).default('cover').meta(meta({
    label: '填充', setter: 'select',
    options: [{ label: '裁切填满', value: 'cover' }, { label: '完整显示', value: 'contain' }, { label: '拉伸', value: 'fill' }],
  })),
  radius: z.number().min(0).max(500).default(0).meta(meta({ label: '圆角', setter: 'slider', min: 0, max: 500, step: 1 })),
});

export type ImageProps = z.infer<typeof ImagePropsSchema>;
